module.exports = __webpack_public_path__ + "static/media/twitter-2.e3fcff42.svg";